module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bRDTVY/Images/cover.jpg?1685327560822",
      "alt": "This image is the cover for the book Uneasy Dreams, Dreamlands"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Uneasy Dreams, Dreamlands\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Sequel to Back to the Dream "), _c('br'), _vm._v("Dreamlands: Book Three")])])]), _c('p', [_vm._v("War came to the Dreamlands when Kyushu was invaded by the Egyptians and Inuzaka Keno’s old nemesis, the Trust. As the lords of Nippon maneuver on and off the field to recover their lands, the peaceful life Keno enjoyed with his lover, Samojirou Aboshi, comes to a violent end. Loyalty to their rulers and the need to drive the enemies from Kyushu tears them apart and forces them to question everything they thought they believed.")]), _vm._v(" "), _c('p', [_vm._v("Trust refugee Mason Kairns, an ally of Keno and Aboshi’s liege lord, struggles to carve a place in a society as hostile as the Northlands he fled. Amidst the chaos and political scheming, the protection of the Hakkenshi may be all that stands between them and disaster.")]), _vm._v(" "), _c('p', [_vm._v("With the fight for Kyushu intensifying, Keno reminds Aboshi more and more of his ancestor: a cursed warrior who spent his life covered in blood. Though Keno has vowed to never take a life, desperation pushes him closer to the madness that devoured his predecessor, and giving in could cost him everything—including Aboshi and the love they share.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Felicitas Ivey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0